// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DzaG","delete":"styles_delete__16aRr","update":"styles_update__3NFHd","add":"styles_add__2Ulco"};